import { Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
import CompanyWithBg from '../../../../assets/images/companyWithBg.svg';
import TraderWithBg from '../../../../assets/images/traderWithBg.svg';
import VerifierWithBg from '../../../../assets/images/verifierWithBg.svg';

export default function AnalyticsCard({ type, data, index, onClick }) {
  const theme = useTheme();
  const style = {
    box: {
      height: '160px',
      // minWidth: '360px',
      backgroundColor: '#F7F8FF',
      borderRadius: '8px',
      paddingLeft: '40px',
      paddingRight: '25px',
      paddingTop: '25px',
      marginRight: '14px',
      marginBottom: '24px',
      cursor: 'pointer',
    },
    cardIconBox: {
      width: 32,
      height: 32,
      borderRadius: 8,
      backgroundColor: theme.palette.primaryLight.main,
      color: '#106AA5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  };
  return (
    <Stack
      style={style.box}
      onClick={() => onClick()}
    >
      <Stack
        style={{}}
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Typography
          className="ff-Roboto fw-medium fs-16"
          style={{ color: '#1A49A3' }}
        >
          {data?.title}
        </Typography>
        <div style={{ ...style.cardIconBox, color: theme.palette.primary.main }}>
          {(index === 0 || index === 1 || index === 2) && (
            <img
              color="#106AA5"
              alt="delivery"
              src={CompanyWithBg}
            />
          )}
          {(index === 3 || index === 4 || index === 5) && (
            <img
              color="#106AA5"
              alt="delivery"
              src={TraderWithBg}
            />
          )}
          {(index === 6 || index === 7 || index === 8) && (
            <img
              color="#106AA5"
              alt="delivery"
              src={VerifierWithBg}
            />
          )}
        </div>
      </Stack>

      {/* <>
        <Stack
          direction={'row'}
          alignItems={'center'}
        >
          <Stack className="mt-[25px]">
            <Typography
              className="ff-Roboto fw-regular fs-12"
              style={{ color: '#00A632' }}
            >
              Active
            </Typography>
            <Typography
              className="ff-Roboto fw-bold fs-16"
              style={{ color: '#343434', marginTop: '10px' }}
            >
              {data?.active}
            </Typography>
          </Stack>
          <Stack className="mt-[25px] ml-[45px]">
            <Typography
              className="ff-Roboto fw-regular fs-12"
              style={{ color: '#F02323' }}
            >
              Blocked
            </Typography>
            <Typography
              className="ff-Roboto fw-bold fs-16"
              style={{ color: '#343434', marginTop: '10px' }}
            >
              {data?.blocked}
            </Typography>
          </Stack>
        </Stack>
      </> */}

      <Stack className="mt-[40px]">
        <Typography
          className="ff-Roboto fw-medium fs-24"
          style={{ color: '#061D30' }}
        >
          {data?.count}
        </Typography>
      </Stack>
    </Stack>
  );
}
